// Sprint 35 item 1: the one registry of built mini-games. The practice-room picker, the guest pick and the server's replay all read
// it, so a game that joins here is offered, picked and scored by itself. A game is a module with
// { id, STEPS, NAME, init(seed, { mode }), observe(state), step(state, input), result(state) } (studio/sprints/35/PLAYERS.md);
// its scoring is the shared integer module itself, so the page and the server give the same score.
import * as bull from './bull.js';
import * as bear from './bear.js';
import * as holden from './holden.js';

// holden is a look of the bear knock (a bear guest who wears Mr Holden plays it), not a third animal: the guest pick weights (balance.js
// GUEST) name only bull and bear, so pickKind never draws it.
export const GAMES = { bull, bear, holden };
export const GAME_IDS = Object.keys(GAMES);
export const gameOf = id => (Object.hasOwn(GAMES, id) ? GAMES[id] : null);

// What the picker shows: one card per built game, in registry order.
export const pickerCards = () => GAME_IDS.map(id => ({ id, name: GAMES[id].NAME, steps: GAMES[id].STEPS, seconds: GAMES[id].STEPS / 15, stub: !!GAMES[id].STUB }));
